/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_List_CatalogInputs */

const cs_property_list_catalog = /** @type {(inputs: Property_List_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerovat katalogové PDF`)
};

const en_property_list_catalog = /** @type {(inputs: Property_List_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate catalog PDF`)
};

/**
* | output |
* | --- |
* | "Generate catalog PDF" |
*
* @param {Property_List_CatalogInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_list_catalog = /** @type {((inputs?: Property_List_CatalogInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_List_CatalogInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_list_catalog(inputs)
	return cs_property_list_catalog(inputs)
});